module.exports = __webpack_public_path__ + "img/15_sterilization_(white).4d095dd3.svg";